import { createFileRoute } from '@tanstack/react-router';
import { InvoiceEditor } from '@/components/custom/invoice-editor';

// An existing invoice. The editor itself is shared with the create route so
// the two cannot drift — see the commentary on `InvoiceEditor`.
export const Route = createFileRoute('/_authenticated/invoices/$id')({
  component: InvoiceDetailPage,
});

function InvoiceDetailPage() {
  const { id } = Route.useParams();
  return <InvoiceEditor invoiceId={id} />;
}
